import type { CartLineItem } from "../../types/product";
import { logger } from "../logger.ts";

const backendBaseUrl = import.meta.env.VITE_BACKEND_BASE_URL;

export const setCartAddress = async (postalAddress: PostalAddress) => {
    return fetch(`${backendBaseUrl}/api/checkout/setAddress`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include", // Include cookies in the request
        body: JSON.stringify(postalAddress),
    });
};

export const setCartItems = async (lineItems: CartLineItem[], totalPrice: number, pvSize: number, pickedDate: string | null) => {
    logger.debug("Setting cart items", { lineItems, totalPrice, pvSize, pickedDate });
    return fetch(`${backendBaseUrl}/api/checkout/setItems`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include", // Include cookies in the request
        body: JSON.stringify({ lineItems: lineItems, totalPrice: totalPrice, pvSize: pvSize, pickedDate: pickedDate }),
    });
}